import JSONAPIClient from '../../JSONAPIClient'

JSONAPIClient.define('dashboard_loan_officer', {
  name: '',
  team_id: '',
  slug: '',
}, { collectionPath: 'dashboard/loan_officers' })
